import {i18n} from 'src/i18n';
import exporterRenders from 'src/modules/shared/exporter/exporterRenders';

export default [
  {
    name: 'id',
    label: i18n('entities.documentCategory.fields.id'),
  },
  {
    name: 'label',
    label: i18n('entities.documentCategory.fields.label'),
  },
  {
    name: 'description',
    label: i18n('entities.documentCategory.fields.description'),
  },
  {
    name: 'createdAt',
    label: i18n('entities.documentCategory.fields.createdAt'),
    render: exporterRenders.datetime(),
  },
  {
    name: 'updatedAt',
    label: i18n('entities.documentCategory.fields.updatedAt'),
    render: exporterRenders.datetime(),
  },
];
